import React from 'react';
import useSecretTapTrigger from '../hooks/useSecretTapTrigger';

/**
 * Zone invisible coin haut-droit : 5 appuis rapides = modal admin (équivalent Ctrl+Shift+A sur téléphone).
 */
export default function AdminSecretTapZone({ onTrigger }) {
  const onTap = useSecretTapTrigger(onTrigger);

  return (
    <button
      type="button"
      aria-hidden="true"
      tabIndex={-1}
      onClick={onTap}
      className="fixed top-0 right-0 z-[100000] w-16 h-16 opacity-0 touch-manipulation"
      style={{ WebkitTapHighlightColor: 'transparent' }}
    />
  );
}
